import Vue from 'vue';

export class Provider extends Vue {}

export default (driver) => new Provider(driver);
